/* eslint-disable sort-keys */
const AGGRID_LICENSE = 'SHI_International_Corp_-_USA__on_behalf_of_Proofpoint_Proofpoint_9Devs22_February_2020__MTU4MjMyOTYwMDAwMA==2921cc0e66b83043ea5edf188dc06c91';

const environmentConfigurations = {
    qa: {
        AUTH_API: 'https://auth-qa.lab.ppops.net',
        CONFIG_API: 'https://monet-api-ci.esp.lab.ppops.net',
        COOKIE_DOMAIN: '.lab.ppops.net',
        DATA_API: 'https://data-qa.lab.ppops.net',
        EIS_URL: 'https://eis-qa.lab.ppops.net',
        END_USER_APP_ID: 'efd-dev-auth',
        END_USER_AUTH_API: 'https://enduserauth-int.lab.ppops.net',
        FEATURE_FLAG_API: 'https://oofinfoe7a.execute-api.us-east-1.amazonaws.com/default/maint-flag',
        NAVBAR_MESSAGE: 'QA',
        USER_LOGOUT_URL: 'https://appefd.lab.ppops.net:3000/verify',
    },
    local: {
        AUTH_API: 'https://heimdall-api-ci.esp.lab.ppops.net',
        CONFIG_API: 'https://monet-api-ci.esp.lab.ppops.net',
        COOKIE_DOMAIN: '.lab.ppops.net',
        DATA_API: 'https://data-dev.emaildefense.proofpoint.com',
        DSP_API: 'https://dsp-api-staging.esp.lab.ppops.net',
        EIS_URL: 'https://eis-dev.lab.ppops.net',
        END_USER_APP_ID: 'efd-dev-auth',
        END_USER_AUTH_API: 'https://enduserauth-int.lab.ppops.net',
        FEATURE_FLAG_API: 'https://oofinfoe7a.execute-api.us-east-1.amazonaws.com/default/maint-flag',
        NAVBAR_MESSAGE: 'Local',
        USER_LOGOUT_URL: 'https://appefd.lab.ppops.net:3000/verify',
    },
    test: {
        AUTH_API: 'https://heimdall-api-ci.esp.lab.ppops.net',
        CONFIG_API: 'https://monet-api-ci.esp.lab.ppops.net',
        COOKIE_DOMAIN: '.lab.ppops.net',
        DATA_API: 'https://data-test.emaildefense.proofpoint.com',
        DSP_API: 'https://dsp-api-staging.esp.lab.ppops.net',
        EIS_URL: 'https://eis-test.lab.ppops.net',
        END_USER_APP_ID: 'efd-metis-test',
        END_USER_AUTH_API: 'https://enduserauth-int.lab.ppops.net',
        FEATURE_FLAG_API: 'https://oofinfoe7a.execute-api.us-east-1.amazonaws.com/default/maint-flag',
        NEW_RELIC_APP_ID: '286997382',
        NEW_RELIC_HOSTNAME: 'metis-test.lab.ppops.net',
        NAVBAR_MESSAGE: 'Test - Automated Testing: Do not modify',
        USER_LOGOUT_URL: 'https://metis-test.lab.ppops.net/verify',
    },
    dev: {
        AUTH_API: 'https://heimdall-api-ci.esp.lab.ppops.net',
        CONFIG_API: 'https://monet-api-ci.esp.lab.ppops.net',
        COOKIE_DOMAIN: '.lab.ppops.net',
        DATA_API: 'https://data-dev.emaildefense.proofpoint.com',
        DSP_API: 'https://dsp-api-staging.esp.lab.ppops.net',
        EIS_URL: 'https://eis-dev.lab.ppops.net',
        END_USER_APP_ID: 'efd-metis-dev',
        END_USER_AUTH_API: 'https://enduserauth-int.lab.ppops.net',
        FEATURE_FLAG_API: 'https://oofinfoe7a.execute-api.us-east-1.amazonaws.com/default/maint-flag',
        NEW_RELIC_APP_ID: '287007610',
        NEW_RELIC_HOSTNAME: 'metis-dev.lab.ppops.net',
        NAVBAR_MESSAGE: 'Dev',
        USER_LOGOUT_URL: 'https://appefd.lab.ppops.net:3000/verify',
    },
    staging: {
        AUTH_API: 'https://auth-efd.proofpoint.com',
        CONFIG_API: 'https://monet-api-ci.esp.lab.ppops.net',
        COOKIE_DOMAIN: '.emaildefense.proofpoint.com',
        DATA_API: 'https://data-staging.emaildefense.proofpoint.com',
        DSP_API: 'https://dsp-api-prod.esp.ppops.net',
        EIS_URL: 'https://eis-staging.emaildefense.proofpoint.com',
        END_USER_APP_ID: 'efd-auth-staging',
        END_USER_AUTH_API: 'https://enduserauth.proofpoint.com',
        FEATURE_FLAG_API: 'https://oofinfoe7a.execute-api.us-east-1.amazonaws.com/default/maint-flag',
        NEW_RELIC_APP_ID: '287008057',
        NEW_RELIC_HOSTNAME: 'metis-staging.emaildefense.proofpoint.com',
        USER_LOGOUT_URL: 'https://metis-staging.emaildefense.proofpoint.com/verify',
        NAVBAR_MESSAGE: 'Staging - Prod Data: Do not modify'
    },
    prod: {
        AUTH_API: 'https://auth-efd.proofpoint.com',
        CONFIG_API: 'TBD',
        COOKIE_DOMAIN: '.emaildefense.proofpoint.com',
        DATA_API: 'https://data.emaildefense.proofpoint.com',
        DSP_API: 'https://dsp-api-prod.esp.ppops.net',
        EIS_URL: 'https://emaildefense.proofpoint.com',
        END_USER_APP_ID: 'efd-auth',
        END_USER_AUTH_API: 'https://enduserauth.proofpoint.com',
        FEATURE_FLAG_API: 'https://oofinfoe7a.execute-api.us-east-1.amazonaws.com/default/maint-flag',
        NEW_RELIC_APP_ID: '187969867',
        NEW_RELIC_HOSTNAME: 'app.emaildefense.proofpoint.com',
        NAVBAR_MESSAGE: '',
        USER_LOGOUT_URL: 'https://app.emaildefense.proofpoint.com/verify',
    }
};

let config = environmentConfigurations[process.env.REACT_APP_STAGE];

export default{
    // Add common config values here
    AGGRID_KEY: AGGRID_LICENSE,
    ...config,
};
